import { ScriptContentAnalysisView } from "@features/aiScriptGeneration/lib/deriveContentAnalysis";
import { Typography } from "@shared/ui";
import React from "react";
import styles from "./CreatorInsightsView.module.scss";
import { TopPerformingContent } from "./TopPerformingContent";

const { Text } = Typography;

interface CreatorInsightsViewProps {
  analysis: ScriptContentAnalysisView;
}

function ContentStyle({
  items,
  showHeading,
}: {
  items: string[];
  showHeading: boolean;
}) {
  if (!items.length) return null;
  const [lead, ...rest] = items;

  return (
    <div className={styles.section}>
      {showHeading ? <Text className={styles.heading}>Content style</Text> : null}
      <div className={styles.styleBlock}>
        <p className={styles.styleLead}>{lead}</p>
        {rest.map((item) => (
          <p key={item} className={styles.styleBody}>
            {item}
          </p>
        ))}
      </div>
    </div>
  );
}

function InsightList({
  title,
  items,
  muted,
}: {
  title: string;
  items: string[];
  muted?: boolean;
}) {
  if (!items.length) return null;

  return (
    <div className={styles.section}>
      <Text className={styles.heading}>{title}</Text>
      <ul className={muted ? styles.listMuted : styles.listAccent}>
        {items.map((item, index) => (
          <li key={`${item}-${index}`}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

export function CreatorInsightsView({
  analysis,
  showContentStyleHeading = true,
}: CreatorInsightsViewProps & { showContentStyleHeading?: boolean }) {
  return (
    <div className={styles.view}>
      <ContentStyle items={analysis.contentStyle} showHeading={showContentStyleHeading} />
      <InsightList title="What Works" items={analysis.whatWorks} />
      <InsightList title="What to Avoid" items={analysis.whatToAvoid} muted />
      <TopPerformingContent posts={analysis.topPerforming} />
    </div>
  );
}
